<script lang="ts" generics="ITEM">
    import {getLocalization} from 'src/core';
    import type {PaginationData} from '../search-manager/pagination';
    import {strParams} from 'shared/utils/pipes';
    import {createEventDispatcher} from 'svelte';
    import {pipe} from 'core/utils';
    import {exists} from 'shared/utils/custom-utils';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';

    export let paginationData: PaginationData<ITEM>;

    const localize = getLocalization();
    const dispatch = createEventDispatcher<{'request-page': number}>();

    $: showedPageNumbersNonEmpty = paginationData.showedPageNumbers.length > 0;
    $: showFirstPageButton = showedPageNumbersNonEmpty && paginationData.showedPageNumbers[0] > 1;
    $: showLastPageButton = showedPageNumbersNonEmpty && exists(paginationData.totalPages) && paginationData.showedPageNumbers[paginationData.showedPageNumbers.length - 1] < paginationData.totalPages;

    function requestPage(pageNumber: number) {
        dispatch('request-page', pageNumber);
    }

    function isPageShowed(pageNumber: number, data: PaginationData<ITEM> | undefined) {
        const lowestPage = data?.lowestPage ?? null;
        const highestPage = data?.highestPage ?? null;

        if (lowestPage === null || highestPage === null) {
            return false;
        }

        return lowestPage.pageNumber <= pageNumber && pageNumber <= highestPage.pageNumber;
    }
</script>

<nav class="pagination-page-selector"
     class:totally-hidden={!showFirstPageButton && !showLastPageButton && paginationData.showedPageNumbers.length === 0}
     aria-label={localize(/* @kp-localization vysledky.Pagination */ 'vysledky.Pagination')}>

    <KpButton additionalClasses="kp-pagination-page-button {isPageShowed(1, paginationData) ? 'active' : ''} {showFirstPageButton ? '' : 'invisible'}"
        isDisabled={!showFirstPageButton}
        aria-label={pipe(localize(/* @kp-localization vysledky.GotToPageX */ 'vysledky.GotToPageX'), strParams('1'))}
        on:click={() => requestPage(1)}>

        1
    </KpButton>

    <span class:invisible={!showFirstPageButton}>
        <UIcon icon="menu-dots"/>
    </span>

    <div class="page-buttons">
        {#each paginationData.showedPageNumbers as pageNumber(pageNumber)}
            <KpButton additionalClasses="kp-pagination-page-button {isPageShowed(pageNumber, paginationData) ? 'active' : ''}"
                aria-label={pipe(localize(/* @kp-localization vysledky.GotToPageX */ 'vysledky.GotToPageX'), strParams(pageNumber.toString()))}
                on:click={() => requestPage(pageNumber)}>

                {pageNumber}
            </KpButton>
        {/each}
    </div>

    <span class:invisible={!showLastPageButton}>
        <UIcon icon="menu-dots"/>
    </span>

    <KpButton additionalClasses="kp-pagination-page-button {isPageShowed(paginationData.totalPages, paginationData) ? 'active' : ''} {showLastPageButton ? '' : 'invisible'}"
        isDisabled={!showLastPageButton}
        aria-label={pipe(localize(/* @kp-localization vysledky.GotToPageX */ 'vysledky.GotToPageX'), strParams(paginationData.totalPages.toString()))}
        on:click={() => requestPage(paginationData.totalPages)}>

        {paginationData.totalPages}
    </KpButton>
</nav>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    .pagination-page-selector {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: @padding-large-horizontal;

        &.totally-hidden {
            display: none;
        }

        .page-buttons {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            gap: @padding-base-horizontal;
        }

        :global {
            .kp-pagination-page-button {
                height: 38px;
                display: flex;
                align-items: center;

                &.active {
                    border-color: var(--accent-blue);
                    color: var(--accent-blue);
                }

                &:disabled {
                    opacity: 0.5;
                }
            }
        }
    }
</style>